import {
  RADIO_CONDITION_ITEMS,
  CHECK_CONDITION_ITEMS,
  AMOUNT_RANGE_CONDITION_ITEMS,
  PEOPLE_RANGE_CONDITION_ITEMS,
  PERIOD_CONDITION_ITEMS,
} from '../constants/conditions'

// @flow

export type Action = {
  type: string
  payload?: any
}

// https://github.com/Microsoft/TypeScript/issues/24243
const getKeys = <T extends {}>(o: T): Array<keyof T> =>
  <Array<keyof T>>Object.keys(o)

export type RadioConditionName = keyof typeof RADIO_CONDITION_ITEMS
export const RADIO_CONDITION_NAMES: RadioConditionName[] = getKeys(
  RADIO_CONDITION_ITEMS
)

export type CheckConditionName = keyof typeof CHECK_CONDITION_ITEMS
export const CHECK_CONDITION_NAMES: CheckConditionName[] = getKeys(
  CHECK_CONDITION_ITEMS
)

export type AmountRangeConditionName = keyof typeof AMOUNT_RANGE_CONDITION_ITEMS
export const AMOUNT_RANGE_CONDITION_NAMES: AmountRangeConditionName[] = getKeys(
  AMOUNT_RANGE_CONDITION_ITEMS
)

export type PeopleRangeConditionName = keyof typeof PEOPLE_RANGE_CONDITION_ITEMS
export const PEOPLE_RANGE_CONDITION_NAMES: PeopleRangeConditionName[] = getKeys(
  PEOPLE_RANGE_CONDITION_ITEMS
)

export type RangeConditionName =
  | AmountRangeConditionName
  | PeopleRangeConditionName

export type PeriodConditionName = keyof typeof PERIOD_CONDITION_ITEMS
export const PERIOD_CONDITION_NAMES: PeriodConditionName[] = getKeys(
  PERIOD_CONDITION_ITEMS
)

export type ConditionName =
  | CheckConditionName
  | AmountRangeConditionName
  | PeopleRangeConditionName
  | PeriodConditionName
  | RadioConditionName
